import { Injectable } from '@angular/core';
import { map, Observable, take } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/components/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AdminGuard {
    constructor(
        private authService: AuthService,
        private router: Router,
    ) {}

    canActivate(): Observable<boolean> {
        return this.authService.me.pipe(
            take(1),
            map((user) => {
                if (user.role === 'OWNER' || user.role === 'ADMIN') {
                    return true;
                }
                this.router.navigate(['/pos']);
                return false;
            }),
        );
    }
}
